/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MoveToDetailsIconContainer from '../../../NDC/component/MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import LabelerDrugTable from '../../../NDC/component/NDCByLabeler/LabelerDrugTable';
import LabelerTableComponent from '../../../NDC/component/NDCByLabeler/LabelerTableComponent';
import {
  getAllLabelerList,
  getDrugListForLabeler,
} from '../../../NDC/store/action';
import {
  checkClaimAndAddToDetailsTable,
  removeFromClaimDetailsTableData,
  setClaimDetailsTableData,
  setClaimDetailsTableRowSelected,
  setClaimErrorPopupMessage,
  setClaimLabelerDrugTableData,
  setClaimLabelerTableData,
  setClaimLoading,
} from '../../store/action';
import ClaimsDetailsTable from './ClaimsDetailsTable';

const SearchByLabeler = ({ fullScreen, setFullScreen, setError }) => {
  const dispatch = useDispatch();
  const [drugTableRow, setDrugTableRow] = useState([]);
  const [labelerRow, setLabelerRow] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [leftGridFullScreen, setLeftGridFullScreen] = useState(false);
  const [rightGridFullScreen, setRightGridFullScreen] = useState(false);
  const [centerGridFullScreen, setCenterGridFullScreen] = useState(false);

  const labelerDrugTableData = useSelector(
    (state) => state.sharedState.claim.labelerDrugTableData
  );

  const labelerTableData = useSelector(
    (state) => state.sharedState.claim.labelerTableData
  );

  const addSingleRowToDetailsTable = () => {
    if (drugTableRow.length === 0) {
      dispatch(setClaimErrorPopupMessage('Please select from the drug names'));
    } else {
      dispatch(setClaimErrorPopupMessage(null));
      dispatch(checkClaimAndAddToDetailsTable(drugTableRow));
      gridApi.deselectAll();
    }
  };

  const addAllToDetailsTable = () => {
    if (labelerDrugTableData.length == 0) {
      dispatch(setClaimErrorPopupMessage('NDC not found'));
    } else {
      dispatch(setClaimErrorPopupMessage(null));
      dispatch(checkClaimAndAddToDetailsTable(labelerDrugTableData));
      gridApi.deselectAll();
    }
  };
  const getLabelerData = async () => {
    dispatch(setClaimLoading(true));
    const response = await getAllLabelerList();
    dispatch(setClaimLoading(false));
    if (!response) {
      dispatch(setClaimErrorPopupMessage('Labeler Not Found'));
    } else {
      dispatch(setClaimErrorPopupMessage(null));
    }

    dispatch(setClaimLabelerTableData(response || []));
  };

  const callAndDataFromAPI = async () => {
    dispatch(setClaimLoading(true));
    const result = await getDrugListForLabeler({
      labelerCode: labelerRow.labelerCode,
      page: 1,
      pageSize: 100,
    });
    dispatch(setClaimLoading(false));

    dispatch(setClaimLabelerDrugTableData(result || []));
  };

  useEffect(() => {
    if (labelerRow) {
      callAndDataFromAPI();
    }
  }, [labelerRow]);

  useEffect(() => {
    getLabelerData();
  }, []);

  const handleFullScreenView = useCallback((screenView, type) => {
    setFullScreen(screenView);
    if (type === 'left') {
      setLeftGridFullScreen(screenView);
    } else if (type === 'right') {
      setRightGridFullScreen(screenView);
    } else if (type === 'middle') {
      setCenterGridFullScreen(screenView);
    }
  }, []);

  return (
    <>
      <div className='col-12'>
        {!leftGridFullScreen && !rightGridFullScreen && (
          <LabelerTableComponent
            labelerTableData={labelerTableData}
            setLabelerRow={setLabelerRow}
            fullScreen={centerGridFullScreen}
            setFullScreen={(screenView) =>
              handleFullScreenView(screenView, 'middle')
            }
          />
        )}
      </div>
      <div className='row mt-4 col-12'>
        {!rightGridFullScreen && (
          <div
            className={`${
              leftGridFullScreen ? 'col-12' : 'col-5'
            } d-flex flex-column`}
            style={{ padding: '36px 15px 0 15px' }}
          >
            <LabelerDrugTable
              labelerRow={labelerRow}
              labelerDrugTableData={labelerDrugTableData}
              setDrugTableRow={setDrugTableRow}
              gridApi={gridApi}
              setGridApi={setGridApi}
              fullScreen={leftGridFullScreen}
              setFullScreen={(screenView) =>
                handleFullScreenView(screenView, 'left')
              }
            />
          </div>
        )}
        {!leftGridFullScreen && !rightGridFullScreen && (
          <div className='col-2 px-2'>
            <MoveToDetailsIconContainer
              handleSingleMove={() => addSingleRowToDetailsTable()}
              handleAllMove={() => addAllToDetailsTable()}
              handleAllRemove={() => {
                dispatch(setClaimDetailsTableData([]));
                dispatch(setClaimDetailsTableRowSelected([]));
              }}
              handleSingleRemove={() => {
                dispatch(removeFromClaimDetailsTableData());
              }}
            />
          </div>
        )}
        {!leftGridFullScreen && (
          <div
            className={`${
              rightGridFullScreen ? 'col-12' : 'col-5'
            } d-flex flex-column p-0`}
          >
            <ClaimsDetailsTable
              fullScreen={rightGridFullScreen}
              setFullScreen={(screenView) =>
                handleFullScreenView(screenView, 'right')
              }
              //showFullScreen={false}
              setError={setError}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default SearchByLabeler;
